<template>
  <div class="section" :class="main_color">
    <div class="part part-map">
      <div class="tle-row medium">
        <div class="tle-col four-fifth mapComponent" :class="{no_edit: editor.mode != 'editing'}" :style="{'z-index': editor.mode == 'editing' ? 100000 : 0}">
          <!-- <div class="part part-images"><el-image
              :parent_data="active_study.etudeData.localisation_projet.image_carte"
              property="src"
              :editable="true"
              max_height="314px"
            />
            </div> -->
            <map-component view class="q-mb-sm" allow_annotations check_programs/>
            <div class="map-description">

            <!-- <div class="comment">
              <div>
                <div class="row">
                  <div class="tle-col half">
                    <p>&nbsp;</p>
                  </div>
                  <div class="tle-col half">
                    <el-textarea
                      class="source"
                      :parent_data="active_study.etudeData.localisation_projet"
                      property="source_carte"
                      :editable="true"
                      placeholder="source de la carte"
                    />
                  </div>
                </div>
                <el-textarea
                  class
                  :parent_data="active_study.etudeData.localisation_projet"
                  property="intro_projet"
                  :editable="true"
                  placeholder="Description de la carte"
                />
              </div>
            </div> -->
          </div>
        </div>
        <div class="tle-col one-fifth">
          <div class="part part-images">
            <el-image
              :parent_data="active_study.etudeData.localisation_projet.images[0]"
              property="src"
              :editable="true"
              max_height="90px"
              edition_position="right"
            />
            <!-- TODO: parent_data and property -->
            <!-- :parent_data="{comment: 'saisir le nom de la photo'}"
              property="comment"  -->
            <el-textarea
              :parent_data="active_study.etudeData.localisation_projet"
              property="titre_photo1"
              :editable="true"
              class="text-center text-italic image-description"
            />
            <br />
            <el-image
              :parent_data="active_study.etudeData.localisation_projet.images[1]"
              property="src"
              :editable="true"
              max_height="90px"
              edition_position="right"
            />
            <!-- TODO: parent_data and property -->
            <el-textarea
              :parent_data="active_study.etudeData.localisation_projet"
              property="titre_photo2"
              :editable="true"
              class="text-center text-italic image-description"
            />
          </div>
      
          <div class="small-question">visite de site réalisée :
            <el-textarea :parent_data="active_study.etudeData.localisation_projet" property="visite_site" :editable="true" inline />
          </div>
          <!-- <div class="description_operation_reference">
            <div class="comment">
              <el-textarea
                class="description_operation_reference"
                :parent_data="active_study.etudeData.localisation_projet"
                property="projet_ref_1"
                :editable="true"
                placeholder="décrivez l'opération 1"
              />
            </div>
            <div class="comment">
              <el-textarea
                class="description_operation_reference"
                :parent_data="active_study.etudeData.localisation_projet"
                property="projet_ref_2"
                :editable="true"
                placeholder="décrivez l'opération 2"
              />
            </div>
            <div class="comment">
              <el-textarea
                class="description_operation_reference"
                :parent_data="active_study.etudeData.localisation_projet"
                property="projet_ref_3"
                :editable="true"
                placeholder="décrivez l'opération 3"
              />
            </div>
            <div class="comment">
              <el-textarea
                class="description_operation_reference"
                :parent_data="active_study.etudeData.localisation_projet"
                property="projet_ref_4"
                :editable="true"
                placeholder="décrivez l'opération 4"
              />
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="part part-detail-site">
      <div class="tle-row">
        <div class="tle-col two-fifth">
          <div>
            <p class="label-small">Accessibilité</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.localisation_projet.notes"
              property="accessibilite"
              :max="10"
              :editable="true"
            />
          </div>
          <div>
            <p class="label-small">Commerces, équipements, services</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.localisation_projet.notes"
              property="commerces_equipements_services"
              :max="10"
              :editable="true"
            />
          </div>
          <div>
            <p class="label-small">Notoriété résidentielle</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.localisation_projet.notes"
              property="notoriete_residentielle"
              :max="10"
              :editable="true"
            />
          </div>
          <div>
            <p class="label-small">Environnement bâti et vue/dégagement</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.localisation_projet.notes"
              property="environnement_bati_vue_degagement"
              :max="10"
              :editable="true"
            />
          </div>
          <div>
            <p class="label-small">Espaces verts</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.localisation_projet.notes"
              property="espaces_verts"
              :max="10"
              :editable="true"
            />
          </div>
          <div>
            <p class="label-small">Nuisances (bruit, pollution, etc...)</p>
            <el-progress-slider
              :parent_data="active_study.etudeData.localisation_projet.notes"
              property="nuisances"
              :max="10"
              :editable="true"
            />
          </div>
          <span class="slider-undertext">Plus le curseur se situe à droite, plus le critère est jugé favorable</span>
        </div>
        <div class="tle-col three-fifth">
          <div class="comment">
            <el-textarea
              class="detail-site"
              :parent_data="active_study.etudeData.localisation_projet"
              property="analyse_site"
              :editable="true"
              placeholder="Répondre à la question : est-ce que  les éléments étudiés permettent d'envisager, actuellement et au moment de la livraison, une attractivité sur le marché locatif, au regard de la cible locative intermédiaire ?"
              height='127px'
              overflow_edit='hidden scroll'
            />
          </div>
          <el-closed-question
            :parent_data="active_study.etudeData.localisation_projet"
            property="objet_demande_cdchabitat"
            :editable="true"
            label="A ce jour, le foncier a-t-il fait l’objet d’une demande d’étude par un autre opérateur que CDC Habitat ?"
          />
          <el-closed-question
            :parent_data="active_study.etudeData.localisation_projet"
            property="secteur_pnru"
            :editable="true"
            label="Localisation du projet en secteur PNRU ?"
          />
        </div>
      </div>
      <div class="tle-row">
        <div class="tle-col half">
          <p class="label main_color_text">Niveau d'attractivité à la livraison du projet</p>
          <el-progress-slider
            :parent_data="active_study.etudeData.localisation_projet.attractivite"
            property="livraison"
            :max="10"
            :editable="true"
            gradient_bg="orange_green_bg"
            :labels="[ 'Faible', 'Élevé' ]"
          />
        </div>
        <div class="tle-col half">
          <p class="label main_color_text">Niveau d'attractivité à terme</p>
          <el-progress-slider
            :parent_data="active_study.etudeData.localisation_projet.attractivite"
            property="a_terme"
            :max="10"
            :editable="true"
            gradient_bg="orange_green_bg"
            :labels="[ 'Faible', 'Élevé' ]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import MapComponent from "@/components/study/editor/elements/MapComponent";
export default {
	name: "section-localisation",
	components: { MapComponent },
	mixins: [PageMixin],
	data: function () {
		return {};
	},
	created: function () {
		if(this.active_study.etudeData.localisation_projet.visite_site == null){
			// RETROCOMPATIBILITY CHECK
			this.active_study.etudeData.localisation_projet.visite_site = "oui/non";
		}
	},
	props: {
		main_color: { default: "faded_red" }
	},
	computed: {
		...mapGetters([ "editor" ]),
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'

.image-description
  opacity 0.5
.small-question
  font-size 9px
.slider-undertext
  font-style italic
  font-size 0.8rem
  font-weight normal
</style>
<style lang="scss">
.mapComponent.no_edit {
  &::before {
    content: "";
    position: absolute;
    z-index: 1000;
    background: #FFFFFF00;
    width: 100%;
    height: 100%;
  }
}

</style>
